module.exports = __webpack_public_path__ + "img/bg-img3.e874b63f.png";